import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { saveAs } from 'file-saver';
import {fetchEnumsFromSchema} from "@/core/tools/forms/fetch_enums_from_schema";
import { group } from 'console';
import { filter } from 'lodash';

interface ExportToCrmReportState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    filter: {
        dZoneGroups: any;
        targetDates: Date[];
    };

    documents: any[];
    schema: any;
    meta: any;
}

const state: ExportToCrmReportState = {
    loading: false,
    loaded: false,
    fatalError: false,

    filter: {
        dZoneGroups: null,
        targetDates: [new Date(), new Date()],
    },

    documents: [],
    schema: {},
    meta: {},
};

function buildFilter(params: any) {
    const queryParams: any = {}

    if (params.targetDates) {
        queryParams.date_from = moment(params.targetDates[0]).format('YYYY-MM-DD');
        queryParams.date_to = moment(params.targetDates[1]).add(1, 'day').format('YYYY-MM-DD')
    }
    if (params.planDates) {
        queryParams.date_from = moment(params.targetDates[0]).format('YYYY-MM-DD');
        queryParams.date_to = moment(params.targetDates[1]).add(1, 'day').format('YYYY-MM-DD')
    }
    if (params.targetDates) {
        queryParams.date_from = moment(params.targetDates[0]).format('YYYY-MM-DD');
        queryParams.date_to = moment(params.targetDates[1]).add(1, 'day').format('YYYY-MM-DD')
    }

    if (params.dZoneGroups) {
        queryParams.delivery_zone_id = params.dZoneGroups;
    }
    if (params.employeeId) {
        queryParams.employee_id = params.employeeId;
    }

    return queryParams;
}

export const REPORT_DATA_ATOM = 'REPORT_DATA_ATOM';
export const REPORT_DATA_CUSTOM = 'REPORT_DATA_CUSTOM';
export const GET_SCHEMA_FACT_VDP = 'GET_SCHEMA_FACT_VDP';

export const actions: ActionTree<ExportToCrmReportState, RootState> = {

    loadData({ commit, state, dispatch }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {

            if (Object.values(params).length > 0) {
              commit('START_LOADING');
              const queries: any[] =[
                vm.$q(GET_SCHEMA_FACT_VDP)
                .raw('schemas.get')
                .action({
                    id: `s:shifts`
                }),
              ]
              const filtersAtom: any[] = []
              const filtersCustom: any[] = []
              if (params.targetDates && params.targetDates[0] && params.targetDates[1]) {
                filtersAtom.push({$and: [
                    {$gte: ['s.shift_date', {$: params.targetDates[0]}]},
                    {$lte: ['s.shift_date', {$: params.targetDates[1]}]},
                ]})
                filtersCustom.push({$and: [
                    {$gte: ['s.shift_date', {$: params.targetDates[0]}]},
                    {$lte: ['s.shift_date', {$: params.targetDates[1]}]},
                ]})
              }
              if (params.planDates && params.planDates[0] && params.planDates[1]) {
                filtersAtom.push({$and: [
                    {$gte: ['sja.bottling_end_date', {$: params.planDates[0]}]},
                    {$lte: ['sja.bottling_end_date', {$: params.planDates[1]}]},
                ]})
                filtersCustom.push({$and: [
                    {$gte: ['scp.done_time', {$: params.planDates[0]}]},
                    {$lte: ['scp.done_time', {$: params.planDates[1]}]},
                ]})
              }
              if (params.finishDates && params.finishDates[0] && params.finishDates[1]) {
                filtersAtom.push({$and: [
                    {$gte: [(params.view == 'mes' ? 'sacp.finish_datetime' : 'sacp.finish_datetime'), {$: params.finishDates[0]}]},
                    {$lte: [(params.view == 'mes' ? 'sacp.finish_datetime' : 'sacp.finish_datetime'), {$: params.finishDates[1]}]},
                ]})
                filtersCustom.push({$and: [
                    {$gte: [(params.view == 'mes' ? 'scp.done_time' : 'scp.done_time'), {$: params.finishDates[0]}]},
                    {$lte: [(params.view == 'mes' ? 'scp.done_time' : 'scp.done_time'), {$: params.finishDates[1]}]},
                ]})
              }
              queries.push(
                vm.$q(REPORT_DATA_ATOM)
                  .raw('documents.list')
                  .action({
                      columns: {
                          id: 's.id',
                          shift_date: 's.shift_date',
                          plan_date: 'sja.bottling_end_date',
                          finish_datetime:  (params.view == 'mes' ? 'sacp.finish_datetime' : 'saetc.finish_datetime'),
                          number: 'sfcp.number',
                          product_name: {$concat: ['p.name', {$: ' '}, 'pc.name']},
                          quantity: (params.view == 'mes' ? 'sa.quantity' : 'saetc.quantity'),
                          weight: (params.view == 'mes' ? {$mul: ['sa.quantity', 'pc.weight']} : 'saetc.weight'),
                          template: {$: 'atom'},
                      },
                      from: "s:shifts",
                      from_as: "s", 
                      joins: [
                          {
                              join: 's:shift_full_plan_atom',
                              type: 'left',
                              as:   'sfcp',
                              on: {
                                $eq: ['sfcp.shift_id', 's.id']
                              }
                          },
                          {
                              join: 's:shift_atom_coock_plan',
                              type: 'left',
                              as:   'sacp',
                              on: {
                                $eq: ['sfcp.plan_id', 'sacp.id']
                              }
                          },
                          {
                              join: 's:shift_journal_atom',
                              type: 'left',
                              as:   'sja',
                              on: {
                                $eq: ['sja.plan_id', 'sacp.id']
                              }
                          },
                          {
                            join: 's:shift_atom',
                            as:   'sa',
                            on: {
                              $eq: ['sa.coock_plan_id', 'sacp.id']
                            }
                          },
                          {
                            join: 's:product_containers',
                            as:   'pc',
                            on: {
                              $eq: ['sa.product_container_id', 'pc.id']
                            }
                          },
                          {
                            join: 's:products',
                            as:   'p',
                            on: {
                              $eq: ['pc.product_id', 'p.id']
                            }
                          },
                          ...params.view == 'crm' ? [{
                            join: {
                              columns: {
                                shift_atom_plan_id: 'saetc.shift_atom_plan_id',
                                product_container_id: 'saetc.product_container_id',
                                quantity: {$sum: 'saetc.quantity'},
                                weight: {$sum: 'saetc.weight'},
                                finish_datetime: {$min: 'saetc.created_at'},
                              },
                              from: 's:shift_atom_exported_to_crm',
                              from_as: 'saetc',
                              groups: [
                                'saetc.shift_atom_plan_id',
                                'saetc.product_container_id'
                              ]
                            },
                            as:   'saetc',
                            on: {
                              $and: [
                                {$eq: ['saetc.shift_atom_plan_id', 'sacp.id']},
                                {$eq: ['saetc.product_container_id', 'pc.id']}
                              ]
                            }

                          }] : []
                      ],
                      page_size: 10000,
                      where: {
                          $and: filtersAtom
                      },
                      order: [
                        {$asc: ['sja.bottling_end_date']}
                      ],
                      group: [
                        's.id',
                        's.shift_date',
                        'sja.bottling_end_date',
                         (params.view == 'mes' ? 'sacp.finish_datetime' : 'saetc.finish_datetime'),
                        'sfcp.number',
                        {$concat: ['p.name', {$: ' '}, 'pc.name']},
                        (params.view == 'mes' ? 'sa.quantity' : 'saetc.quantity'),
                        (params.view == 'mes' ? {$mul: ['sa.quantity', 'pc.weight']} : 'saetc.weight'),
                        {$: 'atom'},
                      ]
                  })
                )
              queries.push(
                vm.$q(REPORT_DATA_CUSTOM)
                  .raw('documents.list')
                  .action({
                      columns: {
                          id: 's.id',
                          shift_date: 's.shift_date',
                          plan_date: 'scp.done_time',
                          finish_datetime: (params.view == 'mes' ? 'scp.done_time' : 'scetc.finish_datetime'),
                          number: 'sfpc.number',
                          product_name: {$concat: ['p.name', {$: ' '}, 'pc.name']},
                          quantity: (params.view == 'mes' ? 'scf.quantity' : 'scetc.quantity'),
                          weight: (params.view == 'mes' ? {$mul: ['scf.quantity', 'pc.weight']} : 'scetc.weight'),
                          template: {$: 'custom'},
                      },
                      from: "s:shifts",
                      from_as: "s", 
                      joins: [
                          {
                              join: 's:shift_full_plan_custom',
                              type: 'left',
                              as:   'sfpc',
                              on: {
                                $eq: ['sfpc.shift_id', 's.id']
                              }
                          },
                          {
                              join: 's:shift_custom_plan',
                              type: 'left',
                              as:   'scp',
                              on: {
                                $eq: ['sfpc.plan_id', 'scp.id']
                              }
                          },
                          {
                              join: 's:shift_custom_fact',
                              type: 'left',
                              as:   'scf',
                              on: {
                                $eq: ['scf.plan_id', 'scp.id']
                              }
                          },
                          {
                            join: 's:product_containers',
                            as:   'pc',
                            on: {
                              $eq: ['scf.product_container_id', 'pc.id']
                            }
                          },
                          {
                            join: 's:products',
                            as:   'p',
                            on: {
                              $eq: ['pc.product_id', 'p.id']
                            }
                          },
                          ...params.view == 'crm' ? [{
                            join: {
                              columns: {
                                shift_custom_plan_id: 'scetc.shift_custom_plan_id',
                                quantity: {$sum: 'scetc.quantity'},
                                weight: {$sum: 'scetc.weight'},
                                finish_datetime: {$min: 'scetc.weight'},
                              },
                              from: 's:shift_custom_exported_to_crm',
                              from_as: 'scetc',
                              groups: [
                                'scetc.shift_custom_plan_id'
                              ]
                            },
                            as:   'scetc',
                            on: {
                              $eq: ['scetc.shift_custom_plan_id', 'scp.id']
                            }

                          }] : []
                      ],
                      page_size: 10000,
                      where: {
                          $and: filtersCustom
                      },
                      order: [
                        {$asc: ['scp.done_time']}
                      ]
                  }),
              )

              vm.$db(queries).then(((result: ServerResult) => {
                  const content_atom = result.getOperation(REPORT_DATA_ATOM).getContent() 
                  const content_custom = result.getOperation(REPORT_DATA_CUSTOM).getContent() 
                  const schema = result.getOperation(GET_SCHEMA_FACT_VDP).getContent().schema;
                  commit('SET_REPORT_DATA', {
                      data: [...content_atom.documents, ...content_custom.documents], schema
                  });
                  commit('LOADED_SUCCESS');
                  resolve();
              }));
            } else {
                resolve();
            }
        })
    },


};

export const mutations: MutationTree<ExportToCrmReportState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.fatalError = true;
    },

    SET_REPORT_DATA(state, {data, schema}) {
        state.documents = data;
        state.schema = schema;
        state.meta = fetchEnumsFromSchema(schema)
    },
};

const getters = {
  total: (state: ExportToCrmReportState) => {
    return state.documents.reduce((acc: any, item: any) => {
        acc.quantity += parseFloat(item.quantity) || 0;
        acc.weight += parseFloat(item.weight) || 0
        return acc
    }, {
        quantity: 0,
        weight: 0,
    });
  },
  exportData(state: ExportToCrmReportState) {
    const csvContent: any[] = [];
    const total = state.documents.reduce((acc: any, item: any) => {
        acc.quantity += parseFloat(item.quantity) || 0;
        acc.weight += parseFloat(item.weight) || 0
        return acc
    }, {
        quantity: 0,
        weight: 0,
    });
    const header = [
      'Дата смены',
      'Партия',
      'Дата партии',
      'Дата перемещения',
      'Этикетка',
      'Количетво, шт',
      'Количество, кг',
    ]
    const subheader = [
      '',
      '',
      '',
      (total.quantity + '').replace('.', ','),
      (total.weight + '').replace('.', ','),
    ]

    state.documents.map((item: any, idx: number) => {
      const row: any[] = [];
      row.push(item.shift_date ? moment(item.shift_date).format('DD.MM.YYYY'): '')
      row.push(item.number)
      row.push(item.plan_date ? moment(item.plan_date).format('DD.MM.YYYY'): '')
      row.push(item.finish_datetime ? moment(item.finish_datetime).format('DD.MM.YYYY'): '')
      row.push(item.product_name)
      row.push((item.quantity + '').replace('.', ','))
      row.push((item.weight + '').replace('.', ','))
      csvContent.push(row)
    })
    return [
        header,
        subheader,
        ...csvContent
    ]
  }
};

export const STORE_KEY = '$_export_to_crm_report';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
